<template>
  <div>
    <nav class="navbar-default navbar-static-side">
      <div class="nav-header profile-element">
        <img src="../../assets/images/logos/logo-white-live.svg" />
      </div>
      <div v-show="sidebarCollapsed">
        <el-menu
          :collapse="sidebarCollapsed"
          :router="false"
          :unique-opened="true"
          style="padding-bottom: 0px !important"
        >
          <el-menu-item index="/interactions">
            <img src="../../assets/images/logos/logo-sm-white.svg" />
            <span slot="title" class="menu-title">home</span>
          </el-menu-item>
        </el-menu>
      </div>
      <perfect-scrollbar>
        <el-menu
          class="custom-scroll side-menu-padding-bottom"
          id="side-menu"
          :collapse="sidebarCollapsed"
          :router="true"
          :unique-opened="true"
        >
          <can action="view" subject="campaigns">
            <el-menu-item index="/campaigns">
              <i class="fa fa-bullhorn" aria-hidden="true"></i>
              <span slot="title" class="menu-title">Campaigns</span>
            </el-menu-item>
          </can>
          <can action="view" subject="interactions">
            <el-submenu index="/interactions" :show-timeout="showSubmenuTimeout">
              <template slot="title" class="menu-title">
                <i class="fa fa-comments-o" aria-hidden="true" />
                <i class="fa fa-angle-right" v-if="sidebarCollapsed"></i>
                <span slot="title" class="menu-title">Interactions</span>
              </template>
              <can action="view" subject="interactions">
                <el-menu-item v-if="pluginEnabled('app.dashboard.radio')" index="/interactions">
                  <span slot="title" class="menu-title">Dashboard</span>
                </el-menu-item>
              </can>
              <can action="view" subject="interactions-search">
                <el-menu-item index="/interactions/search">
                  <span slot="title" class="menu-title">Search</span>
                </el-menu-item>
              </can>
            </el-submenu>
          </can>
          <can action="view" subject="analytics">
            <el-submenu index="/analytics" :show-timeout="showSubmenuTimeout">
              <template slot="title" class="menu-title">
                <i class="fa fa-bar-chart" aria-hidden="false"></i>
                <i class="fa fa-angle-right" v-if="sidebarCollapsed"></i>
                <span slot="title" class="menu-title">Analytics</span>
              </template>
              <!-- <can action="view" subject="analytics">
                <el-menu-item
                  index="/analytics/engagements"
                  v-if="pluginEnabled('app.dashboard.analytics')"
                >
                  <span slot="title" class="menu-title">Engagements</span>
                </el-menu-item>
              </can> -->
              <can action="view" subject="programming">
                <el-menu-item index="/analytics/programming">
                  <span slot="title" class="menu-title">Programming</span>
                </el-menu-item>
              </can>
              <can action="view" subject="afstereo" region="za">
                <el-menu-item index="/analytics/afstereo">
                  <span slot="title" class="menu-title">AFSTEREO</span>
                </el-menu-item>
              </can>
              <can action="view" subject="voice-analytics">
                <el-menu-item
                  index="/analytics/voice-intelligence"
                  v-if="pluginEnabled('app.dashboard.audio_transcriber')"
                >
                  <span slot="title" class="menu-title">Voice Intelligence</span>
                </el-menu-item>
              </can>
            </el-submenu>
          </can>
          <can action="view" subject="qualitative">
            <el-submenu index="/qualitative" :show-timeout="showSubmenuTimeout">
              <template slot="title" class="menu-title">
                <i class="fa fa-cubes" aria-hidden="false"></i>
                <i class="fa fa-angle-right" v-if="sidebarCollapsed"></i>
                <span slot="title" class="menu-title">Qualitative</span>
              </template>
              <can action="view" subject="surveys">
                <el-menu-item v-if="me.is_admin" index="/surveys">
                  <span slot="title" class="menu-title">Qualitative Ratings</span>
                </el-menu-item>
              </can>
              <can action="view" subject="audience">
                <el-menu-item index="/audience/contacts">
                  <span slot="title" class="menu-title">Audience</span>
                </el-menu-item>
              </can>
              <can action="view" subject="admin">
                <!-- TODO: replace user.is_admin with proper permission framework -->
                <el-menu-item index="/surveys/filter" v-if="user.is_admin">
                  <span slot="title" class="menu-title">Survey Filter</span>
                </el-menu-item>
              </can>
              <can action="view" subject="survey-builder">
                <el-menu-item
                  index="/surveybuilder"
                  v-if="pluginEnabled('app.dashboard.qualitative')"
                >
                  <span slot="title" class="menu-title">Survey Builder</span>
                </el-menu-item>
              </can>
            </el-submenu>
          </can>
          <can action="view" subject="social">
            <el-submenu index="/social">
              <template slot="title" class="menu-title">
                <i class="fa fa-share-alt" aria-hidden="false"></i>
                <i class="fa fa-angle-right" v-if="sidebarCollapsed"></i>
                <span slot="title" class="menu-title">Social</span>
              </template>
              <el-menu-item index="/social/analytics">
                <span slot="title" class="menu-title">Social Analytics</span>
              </el-menu-item>
              <el-menu-item index="/social/schedules">
                <span slot="title" class="menu-title">Scheduled Posts</span>
              </el-menu-item>
            </el-submenu>
          </can>
          <can action="view" subject="profiles">
            <el-submenu index="/profiles" :show-timeout="showSubmenuTimeout">
              <template slot="title" class="menu-title">
                <i class="fa fa-users" aria-hidden="true"></i>
                <i class="fa fa-angle-right" v-if="sidebarCollapsed"></i>
                <span slot="title" class="menu-title">Profiles</span>
              </template>
              <can action="view" subject="profiles">
                <el-menu-item index="/profiles">
                  <span slot="title" class="menu-title">Profiles Dashboard</span>
                </el-menu-item>
              </can>
              <can action="view" subject="profiles">
                <el-menu-item
                  v-if="pluginEnabled('app.profiles.segmentation')"
                  index="/segmentation"
                  title="Smart Segmentation and Targeting"
                >
                  <span slot="title" class="menu-title">Smart Segmentation</span>
                </el-menu-item>
              </can>
              <can action="view" subject="profiles">
                <el-menu-item v-if="pluginEnabled('app.profiles.permissions')" index="/permissions">
                  <span slot="title" class="menu-title">PI Management</span>
                </el-menu-item>
              </can>
            </el-submenu>
          </can>
          <can action="view" subject="channels">
            <el-menu-item index="/channels">
              <i class="fa fa-exchange" aria-hidden="true"></i>
              <span slot="title" class="menu-title">Channels</span>
            </el-menu-item>
          </can>
          <can action="view" subject="filebox">
            <el-menu-item index="/filebox">
              <i class="fa fa-folder-open" aria-hidden="true"></i>
              <span slot="title" class="menu-title">Filebox</span>
            </el-menu-item>
          </can>
          <can action="view" subject="company">
            <el-menu-item index="/company">
              <i class="fa fa-building" aria-hidden="true"></i>
              <span slot="title" class="menu-title">My Station</span>
            </el-menu-item>
          </can>
          <can action="view" subject="admin">
            <el-submenu v-if="user.is_staff" index="/admin" :show-timeout="showSubmenuTimeout">
              <template slot="title" class="menu-title">
                <i class="fa fa-cubes" aria-hidden="false"></i>
                <i class="fa fa-angle-right" v-if="sidebarCollapsed"></i>
                <span slot="title" class="menu-title">Admin</span>
              </template>
              <can action="view" subject="admin-station-activity">
                <el-menu-item index="/admin/stationActivity">
                  <span slot="title" class="menu-title">Station Activity</span>
                </el-menu-item>
              </can>
              <can action="view" subject="email-dashboard">
                <el-menu-item index="/admin/templates">
                  <span slot="title" class="menu-title">Email Templates</span>
                </el-menu-item>
              </can>
              <can action="view" subject="profiles">
                <el-menu-item index="/profiles_admin">
                  <i class="fa fa-users" aria-hidden="true"></i>
                  <span slot="title" class="menu-title">Profiles</span>
                </el-menu-item>
              </can>
            </el-submenu>
          </can>
        </el-menu>
      </perfect-scrollbar>
    </nav>
  </div>
</template>
<script>
/* eslint consistent-return: "off" */

import { mapState } from 'vuex';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import Can from '@/components/permissions/Can';

export default {
  name: 'SideMenu',
  components: {
    Can,
    PerfectScrollbar,
  },
  data: () => ({
    showUserMenu: false,
    showSubmenuTimeout: 150,
  }),

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState(['sidebarCollapsed']),
    ...mapState('plugin', ['plugins']),
    ...mapState('user', ['me']),
  },

  methods: {
    pluginEnabled(pluginRoute) {
      return this.plugins.filter(plugin => plugin.plugin_route === pluginRoute).length;
    },
  },
};
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"></style>

<style lang="scss">
@import '../../assets/style/_variables_live.scss';

.custom-scroll::-webkit-scrollbar {
  width: 0;
}

.custom-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 1);
  border-radius: 15px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  border-radius: 15px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  background: lightgrey;
}

.side-menu-padding-bottom {
  padding-bottom: 200px;
}

$menu-highlight: lighten($violent-violet, 2%);

.side-meun-logo {
  padding-left: 1em;
  padding-right: 2em;
  position: fixed;
  bottom: 30px !important;
  z-index: 9999;
  width: 17em;
}

@media (max-height: 650px) {
  .side-meun-logo {
    display: none;
  }
}

.mini-navbar .side-meun-logo img {
  width: 42px;
}

.profile-element {
  text-align: center;

  .profile-name {
    color: white;
    font-size: 1.2em;
    font-weight: bold;
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: $nav-text-color;
  outline: 0;
}

.el-dropdown-menu {
  min-width: 150px;

  .el-dropdown-menu__item {
    .fa {
      padding-right: 8px;
      padding-bottom: 0px !important;
    }
  }
}

.el-menu {
  background: $colony-dark-background;
  border-right: 2px solid $colony-dark-background;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 80vh;

  i.fa {
    padding-right: 18px;
    font-size: 1.4em;
    color: $nav-icon-color;
    width: 30px;
  }

  .el-menu-item,
  .el-submenu__title {
    color: $nav-text-color;

    .el-submenu__icon-arrow {
      color: $nav-icon-color;
    }
  }

  .el-submenu {
    .el-menu {
      background: darken($violent-violet, 10%);
      padding-bottom: 0px !important;
      overflow-y: hidden !important;
      &:hover {
        color: $nav-text-highlight !important;
        background: darken($violent-violet, 10%);
      }
    }

    &.is-opened {
      background: darken($violent-violet, 10%);
    }
  }

  img {
    width: 22px;
    height: auto;
    margin-right: 5px;
  }

  span.menu-title {
    font-size: 0.9em;
    font-weight: 400;
  }
}

.el-menu--collapse {
  width: 100%;

  overflow: hidden;
  i.fa {
    padding-right: 5px;
  }
}

.el-menu-item,
.el-submenu__title {
  &:hover {
    background: $menu-highlight;
    color: $nav-text-highlight !important;
  }

  &:focus,
  &.is-active {
    background: inherit;
    border-left: 3px solid lighten($colony-primary, 20%);
    color: $white-solid;
    font-size: 1.1em !important;
  }
}

.el-submenu {
  .el-menu {
    border: 0 !important;
  }
}

.el-menu {
  &.v-leave,
  &.v-leave-active {
    .el-menu-item .menu-title,
    .el-submenu__title .menu-title {
      display: none;
    }
  }

  &.v-enter,
  &.v-enter-active {
    .el-menu-item .menu-title,
    .el-submenu__title .menu-title {
      display: inherit;
    }
  }
}

.mini-navbar {
  .el-menu-item .menu-title,
  .el-submenu__title .menu-title {
    &.v-enter-to,
    &.v-leave-to {
      display: none;
    }
  }

  .el-menu-item img,
  .el-submenu__title img {
    // padding: 2px;
    margin-left: -5px;
    margin-right: 0;
    width: 35px;
  }

  #logo {
    width: 42px;
    height: 42px;
    left: 12px;

    background: url('../../assets/images/logos/logo-sm-white.svg');
    background-size: 42px 42px;
  }
}
</style>



// WEBPACK FOOTER //
// SideMenu.vue?4f93c8c8